import Head from "next/head";
import { Inter } from "next/font/google";
import styles from "@/styles/Home.module.css";
import Footer from "@/components/Footer";
import Catalogue from "@/components/Catalogue";
import Navbar from "@/components/Navbar";
import { useEffect, useState } from "react";
import { logError } from "@/components/logger";

const inter = Inter({ subsets: ["latin"] });

export default function Vente() {

  const [database, setDatabase] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch("/api/database");
        if (response.ok) {
          const data = await response.json();
          setDatabase(data.db);
          sessionStorage.setItem("bumpfunDB", JSON.stringify(data.db));
        } else {
          throw new Error("Failed to fetch data");
        }
        const promotionResponse = await fetch("/api/promotion");
        if (promotionResponse.ok) {
          const data = await promotionResponse.json();
          sessionStorage.setItem("specialPromo", data.promotion);
        } else {
          throw new Error("Failed to fetch promotion variable");
        }
      } catch (err) {
        logError("vente.fetch", err, {});
      }
    };
    fetchData();
  }, []);

  if (!database) {
    return (
      <>
      <Head>
        <title>Vente | Bumpfun</title>
        <meta name="description" content="BumpFun vente des châteaux gonflables." />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />
        <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
        <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
        <link rel="manifest" href="/site.webmanifest" />
      </Head>
      <main className={`${styles.main} ${inter.className}`}>
        <Navbar />
        <div className={[styles.page, styles.buy].join(" ")}>
          <h1>En cours de chargement...</h1>
        </div>
        <Footer />
      </main>
    </>
    );
  }

  return (
    <>
      <Head>
        <title>Vente | Bumpfun</title>
        <meta name="description" content="BumpFun vente des châteaux gonflables." />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />
        <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
        <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
        <link rel="manifest" href="/site.webmanifest" />
      </Head>
      <main className={`${styles.main} ${inter.className}`}>
        <Navbar />
        <div className={[styles.page, styles.buy].join(" ")}>
          <h1>Offre vente</h1>
          <p>Interessé dans l&apos;achat d&apos;un château gonflable?</p>
          <p>
            Nous disposons d&apos;une grande gamme de châteaux gonflables nouveaux et seconde main.
          </p>
          <a className={styles.priceIn} href="mailto:info@bumpfun.be">
            N&apos;hésitez pas à nous contacter pour plus d&apos;informations.
          </a>
          <div className={styles.catalogueBox}>
            <Catalogue type="buy" title="Verkoop" content="castle" database={database} />
          </div>
        </div>
        <p className={styles.btw}>*Les prix affichés sont hors TVA.</p>
        <Footer />
      </main>
    </>
  );
}
